import { useState } from "react";
import PhoneNumber from "../app/PhoneNumber";

export default function SenderInfo() {
  const [userCountry, setUserCountry] = useState("");
  const [details, setDetails] = useState({
    mobile: "",
    password: "",
  });
  function getMobile(dialCode: string, mobile: string) {
    setUserCountry(dialCode);
    setDetails({ ...details, mobile });
  }
  return (
    <div className="space-y-5">
      <div>
        <label htmlFor="receiverLocation" className="secondary-text">
          Sender's Location
        </label>
        <div className="input-field">
          <input
            type="text"
            value="24 Nnamdi Amani Street"
            className="w-full"
            placeholder="Shomolu, Lagos"
          />
        </div>
      </div>
      <div>
        <label htmlFor="receiverName" className="secondary-text">
          Sender's Name
        </label>
        <div className="input-field">
          <input
            type="text"
            value="Divine Edeh"
            className="w-full"
            placeholder="Enter receiver's name here"
          />
        </div>
      </div>
      <div>
        <PhoneNumber returnValues={getMobile} />
      </div>
    </div>
  );
}
